import { FetchRequest } from '@rails/request.js';
import init from '../../common/base/init';

init(() => {
  const sendRequestButton = document.querySelector('.-certificate-request .button');
  if (!sendRequestButton) return;

  sendRequestButton.addEventListener('click', async (e) => {
    e.preventDefault();
    sendRequestButton.disabled = true;

    try {
      const request = new FetchRequest("POST", "/play/skicka-ansokan", {
        responseKind: "turbo-stream",
      });

      const response = await request.perform();

      if (response.ok) {
        const message = document.querySelector(
          '.-certificate-request #certificate-message'
        );

        const confirmation = document.querySelector(
          '.-certificate-request #certificate-confirmation'
        );

        if (message) message.classList.add('-hide-message');
        if (message) message.classList.remove('-message');
        if (confirmation) confirmation.classList.remove('-confirmation');
        if (confirmation) confirmation.classList.add('-confirmation-margin');
      }
    } catch (error) {
      sendRequestButton.disabled = false;
      console.error("Request failed", error);
    }
  });
});
